import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackStopSearchClick } from './tracking';
import { ChatbotButton } from '../../components/ChatbotButton';
import { IconPause16 } from '../../components/Icons/IconPause16';
import { applyPeriodicitySettings } from '../../thunks/chatbot';
import { TThunkDispatch } from '../../types/redux/thunk';

export const StopSearchButtonContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const onClick = React.useCallback(() => {
    trackStopSearchClick();
    dispatch(applyPeriodicitySettings('never'));
  }, [dispatch]);

  return (
    <ChatbotButton onClick={onClick} theme="fill_white_primary" beforeIcon={<IconPause16 color="icon-main-default" />}>
      Остановить
    </ChatbotButton>
  );
};
